// removed by extract-text-webpack-plugin
module.exports = {"container":"_3WZCrOn87NrKXLwAAai_o","title":"_1g3dEgnlW9Y0IPfECDOQ7_","twoFactorActivatedText":"_2kgs1wt5JhUJHCy8k12VCI","twoFactorActivatedIcon":"_2UoyqSd1u26hre5eCRB4o6","yourAccountIsSecure":"_3iZde2elOmDGsZ9qqsNDph","googleIcon":"_3o_7bcmPs4TuZ9tW5AUV6H","appStoreIcon":"JFptodU3fBfvmkRmUMCkl","instructionStep":"yCvEeGru3ctwigMPrCVJm","addManually":"_31XPh6AkyZVOBaz5OQbVyh","addManuallyPre":"_1_DzBy3g6Q71naioxhJyZr","desactivar":"_2QduoOtfyX7bpXGol5IZyi"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Security/TwoFactor/styles.css
// module id = 2651
// module chunks = 0